
    <div class="modal-header modal-header-warning">
      <h4 class="modal-title">
        <span translate>{{title}}</span>
      </h4>
      <h4 class="modal-title">
        <a style="float: top" *ngIf="enableClosingActions"><i id="close_alert_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
      </h4>
    </div>
    <div class="modal-body">
      <app-ajax-loading-indicator *ngIf="message === undefined"></app-ajax-loading-indicator>
      <span *ngIf="message !== undefined">{{message}}</span>
      <a id="alert_modal_link" *ngIf="link" rel="noopener noreferrer" [href]="link" target="_blank">{{linkTitleText}}</a>
    </div>
    <div class="modal-footer" *ngIf="showOkButton && enableClosingActions">
      <button id="confirm_alert_modal_button" type="button" class="btn btn-secondary-action confirm" (click)="cancel()">OK</button>
    </div>
  